import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { map as __map, filter as __filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../api-configuration";
import * as i2 from "@angular/common/http";
/**
 * Site Rest Controller
 */
class SiteRestControllerService extends __BaseService {
    constructor(config, http) {
        super(config, http);
    }
    /**
     * @return OK
     */
    getCurrentSiteUsingGETResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('GET', this.rootUrl + `/api/site`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    getCurrentSiteUsingGET() {
        return this.getCurrentSiteUsingGETResponse().pipe(__map(_r => _r.body));
    }
    /**
     * @return OK
     */
    listContentSourceUsingGETResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('GET', this.rootUrl + `/api/site/contentsources`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    listContentSourceUsingGET() {
        return this.listContentSourceUsingGETResponse().pipe(__map(_r => _r.body));
    }
    /**
     * @param siteContentSource siteContentSource
     * @return OK
     */
    updateContentSourceUsingPOSTResponse(siteContentSource) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        __body = siteContentSource;
        let req = new HttpRequest('POST', this.rootUrl + `/api/site/contentsources`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param siteContentSource siteContentSource
     * @return OK
     */
    updateContentSourceUsingPOST(siteContentSource) {
        return this.updateContentSourceUsingPOSTResponse(siteContentSource).pipe(__map(_r => _r.body));
    }
}
SiteRestControllerService.ngInjectableDef = i0.defineInjectable({ factory: function SiteRestControllerService_Factory() { return new SiteRestControllerService(i0.inject(i1.ApiConfiguration), i0.inject(i2.HttpClient)); }, token: SiteRestControllerService, providedIn: "root" });
export { SiteRestControllerService };
